import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import { ClientService, Layout, Loading } from '../../../lib/layout';
import { ClientService, Layout, Loading,Error } from 'quanta-flows/modules/layout';
import { LOB_PRODUCT_LIST } from './queries';
import ViewRenewPolicyHealth from './health';
// import ViewRenewPolicyMotor from './two-wheeler';
import ViewRenewPolicyMotor from './two-wheeler';
import ViewRenewPolicyMotorGCV from './GCV';
import ViewRenewPolicyMotorPCV from './PCV';
import { Card, useResponsiveParams, Text } from 'quanta-ui';
// import { initViewRenewPolicyVar } from './health/_graphql/state';
import { initViewRenewPolicyVar } from 'quanta-flows/modules/policy/renewal/health/state';
import { initViewRenewMotorPolicyVar } from 'quanta-flows/modules/policy/renewal/motor/state'

export default function ViewRenewPolicy(props) {
  const {
    customerID,
    //  product_name ,
    proposal_number,
    // product_code,
    renewal_mode,
    rcStatus,
    modify
    
  } = useParams();
  const params = useParams();
   const product_name =props?.product_name?props?.product_name:params?.product_name;
   const product_code =props?.product_code ?props?.product_code
   :params?.product_code;
  const {
    loading: loadingLobProductList,
    error: errorLobProductList,
    data: dataLobProductList,
  } = useQuery(LOB_PRODUCT_LIST, { fetchPolicy: 'cache-first' });


  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  useEffect(() => {
    const initAllReactiveVars = () => {
      initViewRenewPolicyVar();
      initViewRenewMotorPolicyVar();
    }
    return () => initAllReactiveVars();
  }, []);

  if (loadingLobProductList) {
    return <Loading />;
  } 
  //  console.log(`loadingLobProductList`,loadingLobProductList);
  if (errorLobProductList) {
    return <Error error={errorLobProductList} />;
  }

  const { lobProductList } = dataLobProductList;
 
  // console.log(lobProductList);
  // const lob_name = lobProductList?.find(
  //   (lob) =>
  //     lob?.products?.find(
  //       (product) =>
  //         product?.product_code?.toString()?.toLowerCase() ===
  //           product_code?.toString()?.toLowerCase() &&
  //         product?.product_name?.toString()?.toLowerCase() ===
  //           product_name?.toString()?.toLowerCase(),
  //     ) !== undefined,
  // )?.lob_name ;
 const lob_name =product_code?.toString()=='2880'?'Health' :'Motor';
 if (lob_name?.toString()?.toLowerCase() === 'motor' && (product_code?.toString() === '3137' ||
 product_code?.toString() === '3140')) {
 return (
   <ViewRenewPolicyMotorGCV
   {...{
     customerID,
     product_name,
     proposal_number,
     product_code,
     renewal_mode,
     lobProductList,
     lobName: lob_name,
     rcStatus,
     modify
   }}
 />
 );
}
if (lob_name?.toString()?.toLowerCase() === 'motor' && (product_code?.toString() === '3183' ||
product_code?.toString() === '3184')) {
return (
  <ViewRenewPolicyMotorPCV
  {...{
    customerID,
    product_name,
    proposal_number,
    product_code,
    renewal_mode,
    lobProductList,
    lobName: lob_name,
    rcStatus,
    modify
  }}
/>
);
}
 if (lob_name?.toString()?.toLowerCase() === 'health') {
    return (
      <ViewRenewPolicyHealth
        {...{
          customerID,
          product_name,
          proposal_number,
          product_code,
          rcStatus, //ST Renewed
          renewal_mode,
        }}
      />
    );
  }
  else if (lob_name?.toString()?.toLowerCase() === 'motor' && (product_code?.toString() === '3121' ||
    product_code?.toString() === '3176' ||
    product_code?.toString() === '3151')) {
    return (
      <ViewRenewPolicyMotor
      {...{
        customerID,
        product_name,
        proposal_number,
        product_code,
        renewal_mode,
        lobProductList,
        lobName: lob_name,
        rcStatus,
        modify
      }}
    />
    );
  }
   else {
    return (
      <Layout
        service_type={ClientService}
        nav={['Policy', 'View Renew Policy']}
      >
        <Card className="h-screen" severity={`error`}>
          <Text
            severity={'error'}
            className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
          >
            Given Product Information is not Available or Invalid.
          </Text>
        </Card>
      </Layout>
    );
  }
}
